import Phaser from 'phaser';

export function ensureNavalFallbackTextures(scene: Phaser.Scene) {
  createShip(scene, 'fallback.ship.player', 0x7f1f22, 0xe5bd68, 0x2a1710);
  createShip(scene, 'fallback.ship.enemy', 0x244d67, 0xe6dcc4, 0x171b20);
  createShip(scene, 'fallback.ship.neutral', 0x447468, 0xd1ad61, 0x251b14);
  if (!scene.textures.exists('fallback.naval-water')) {
    const graphics = scene.make.graphics({ x: 0, y: 0 });
    graphics.fillStyle(0x225d73, 1).fillRect(0, 0, 64, 64);
    graphics.lineStyle(2, 0x77bdc7, 0.55);
    for (let y = 8; y < 64; y += 14) graphics.beginPath().arc(32, y, 38, Phaser.Math.DegToRad(190), Phaser.Math.DegToRad(350)).strokePath();
    graphics.generateTexture('fallback.naval-water', 64, 64);
    graphics.destroy();
  }
}

function createShip(scene: Phaser.Scene, key: string, sailColor: number, trimColor: number, hullColor: number) {
  if (scene.textures.exists(key)) return;
  const graphics = scene.make.graphics({ x: 0, y: 0 });
  graphics.fillStyle(0x000000, 0.22).fillEllipse(64, 67, 105, 14);
  graphics.fillStyle(hullColor, 1).lineStyle(3, trimColor, 1);
  graphics.beginPath().moveTo(11, 48).lineTo(119, 45).lineTo(105, 66).lineTo(31, 67).closePath().fillPath().strokePath();
  graphics.fillStyle(sailColor, 1).lineStyle(2, trimColor, 1).fillRect(35, 38, 64, 13).strokeRect(35, 38, 64, 13);
  graphics.lineStyle(4, 0x31231a, 1).lineBetween(65, 44, 65, 10);
  graphics.fillStyle(0xf2ead5, 0.94).lineStyle(2, trimColor, 1);
  graphics.beginPath().moveTo(67, 13).lineTo(68, 42).lineTo(105, 28).closePath().fillPath().strokePath();
  graphics.fillStyle(sailColor, 1).lineStyle(1, trimColor, 1);
  graphics.beginPath().moveTo(25, 44).lineTo(24, 23).lineTo(48, 31).closePath().fillPath().strokePath();
  graphics.generateTexture(key, 128, 80);
  graphics.destroy();
}